import React, { useState, useEffect } from 'react';
import Sidebar from '../layouts/Sidebar';
import Header from '../layouts/Header';
import axios from 'axios';
import {
    CustomDropDownField, CustomInputField, CustomTextArea
} from "../CustomComponents/ReusableComponents";
import { useAuth } from '../contexts/AuthContext';
import { useHistory, useParams } from "react-router-dom";

const AddAccountComponent = () => {
    const { auth } = useAuth();
    const history = useHistory();
    const { id } = useParams();

    const [menu, setMenu] = useState(false);
    const [accountTypes, setAccountTypes] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [vendors, setVendors] = useState([]);

    const [formData, setFormData] = useState({
        account_type_id: '',
        code: '',
        customer_id: '',
        description: '',
        is_active: '1',
        name: '',
        vendor_id: ''
    })
    const toggleMobileMenu = () => {
        setMenu(!menu);
    };

    const handleToggle = () => {
        setFormData(prevFormData => ({
            ...prevFormData,
            is_active: prevFormData.is_active === '1' ? '0' : '1'
        }));
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };


    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_V1_BASE_URL}/get_dropdown_data`,
                    {
                        models: [
                            { model_name: "Customer" },
                            { model_name: "AccountType" },
                            { model_name: "Vendor" },
                        ]
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${auth}`
                        }
                    }
                );
                setAccountTypes(response.data.content.AccountType || []);
                setCustomers(response.data.content.Customer || []);
                setVendors(response.data.content.Vendor || []);
            } catch (err) {
                // setError("Failed to load dropdown data");
            }
        };

        const fetchAccountData = async () => {
            if (id) {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_V1_BASE_URL}/accounts/${id}`,
                        {
                            headers: {
                                Authorization: `Bearer ${auth}`
                            }
                        }
                    );
                    setFormData(response.data);
                } catch (err) {
                    // Handle error
                }
            }
        };

        fetchDropdownData();
        fetchAccountData();
    }, [auth, id]);
    
    const handleSubmit = async e => {
        e.preventDefault();
        try {
            const response = id
                ? await axios.put(
                    `${process.env.REACT_APP_API_V1_BASE_URL}/accounts/${id}`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${auth}`,
                            "Content-Type": "application/json"
                        }
                    }
                )
                : await axios.post(
                    `${process.env.REACT_APP_API_V1_BASE_URL}/accounts`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${auth}`,
                            "Content-Type": "application/json"
                        }
                    }
                );

            console.log("Account saved successfully", response.data);
            history.push('/accounts');
        } catch (err) {
            console.error("Failed to save Account", err);
            // Handle error
        }
    };

    return(
        <>
            <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
                <Header onMenuClick={toggleMobileMenu} />
                <Sidebar />
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="card mb-0">
                            <div className="card-body">
                                <div className="page-header">
                                    <div className="content-page-header">
                                    <h5>{id ? 'Edit Account' : 'Add Account'}</h5>
                                    </div>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <CustomDropDownField
                                                options={accountTypes.map(c => ({
                                                    value: c.id,
                                                    label: c.name
                                                }))}
                                                labelText="Account Type"
                                                name="account_type_id"
                                                onChange={handleChange}
                                            /> 
                                    </div>
                                    {/* setCustomers */}
                                    <div className="row">
                                        <CustomDropDownField
                                                options={customers.map(c => ({
                                                    value: c.id,
                                                    label: c.name
                                                }))}
                                                labelText="Customers"
                                                name="customer_id"
                                                onChange={handleChange}
                                            /> 
                                        <CustomDropDownField
                                                options={vendors.map(c => ({
                                                    value: c.id,
                                                    label: c.name
                                                }))}
                                                labelText="Vendors"
                                                name="vendor_id"
                                                onChange={handleChange}
                                            />
                                    </div>

                                    <div className="row">
                                        <CustomInputField
                                            inputType="text"
                                            labelText="Account Name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                        <CustomInputField
                                            inputType="text"
                                            labelText="Account Code"
                                            name="code"
                                            value={formData.code}
                                            onChange={handleChange}
                                        />
                                    </div>
                                                
                                    
                                    <div className="col-lg-6 my-3">
                                        <CustomTextArea
                                            rows={5}
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            placeholder="Description"
                                        />
                                    </div>
                                    
                                    <div className="mb-3">
                                        <label className="form-label">Active</label>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isActiveSwitch"
                                                checked={formData.is_active === '1'}
                                                onChange={handleToggle}
                                            />
                                            <label className="form-check-label" htmlFor="isActiveSwitch">
                                                {formData.is_active === '1' ? 'Active' : 'Inactive'}
                                            </label>
                                        </div>
                                    </div>
                                    
                                    <div className="text-end">
                                        <button
                                            type="reset"
                                            className="btn btn-primary cancel me-2"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                        >
                                            Save
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddAccountComponent;